import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { CommonSharedService } from 'src/app/shared/services/common-shared.service';
import { RadioButtonClickEvent, RadioButtonModule } from 'primeng/radiobutton';
import { CommonModule } from '@angular/common';
import { paymentMethod } from '../../../../../../express-tRPC/src/shared/types';

@Component({
  selector: 'new-payment-method-form',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MessagesModule, InputTextModule, IconFieldModule, InputIconModule, RadioButtonModule],
  providers: [MessageService],
  templateUrl: './new-payment-method-form.component.html',
  styleUrl: './new-payment-method-form.component.scss'
})
export class NewPaymentMethodFormComponent {

  paymentMethodTypes: any = [
    {
      name: 'Credit Card',
      value: 'Credit Card'
    },
    {
      name: 'eCheck',
      value: 'eCheck'
    }
  ];

  accountTypes: any = [
    {
      name: 'Checking',
      value: 'checking'
    },
    {
      name: 'Savings',
      value: 'savings'
    }
  ];

  cardForm: any;
  @Input('tokenizationSourceKey') tokenizationSourceKey: string | undefined;
  @Input('echeckPaymentEnabled') echeckPaymentEnabled: boolean | undefined;

  newPaymentMethodFormGroup!: FormGroup;
  savePaymentMethodFormSubmitted: boolean = false;

  @Output() paymentMethodDetailsEvent = new EventEmitter<paymentMethod>();

  constructor(private messageService: MessageService, private commonSharedService: CommonSharedService) { }

  async ngOnInit() {
    this.newPaymentMethodFormGroup = new FormGroup({
      payment_method_type: new FormControl<string | null>('Credit Card', [Validators.required]),
      name: new FormControl<string | null>(null, [Validators.required]),
      account_owner_name: new FormControl<string | null>(null, []),
      routing_number: new FormControl<string | null>(null, []),
      account_number: new FormControl<string | null>(null, []),
      account_type: new FormControl<string | null>('checking', []),
    });

    this.paymentMethodDetailsEvent.emit(this.newPaymentMethodFormGroup.value);
  }

  public async initPaymentIframe() {
    if (this.cardForm?.['_iframe']) {
      this.cardForm?.destroy();
    }
    this.cardForm = await this.commonSharedService.initializeAcceptBluePaymentIframe(this.tokenizationSourceKey!);
  }

  async paymentMethodChanged(event: RadioButtonClickEvent): Promise<void> {
    this.messageService.clear();
    this.savePaymentMethodFormSubmitted = false;

    if (event.value == "Credit Card") {
      await this.initPaymentIframe()

      this.newPaymentMethodFormGroup.get('account_owner_name')?.setValidators([]);
      this.newPaymentMethodFormGroup.get('routing_number')?.setValidators([]);
      this.newPaymentMethodFormGroup.get('account_number')?.setValidators([]);
      this.newPaymentMethodFormGroup.get('account_type')?.setValidators([]);

    } else {

      this.newPaymentMethodFormGroup.get('account_owner_name')?.setValidators(Validators.required);
      this.newPaymentMethodFormGroup.get('routing_number')?.setValidators([Validators.required, Validators.pattern('^[0-9]{9}$')]);
      this.newPaymentMethodFormGroup.get('account_number')?.setValidators([Validators.required, Validators.pattern(new RegExp(/^[0-9]+$/)), Validators.maxLength(17)]);
      this.newPaymentMethodFormGroup.get('account_type')?.setValidators(Validators.required);

    }

    this.newPaymentMethodFormGroup.get('account_owner_name')?.updateValueAndValidity();
    this.newPaymentMethodFormGroup.get('routing_number')?.updateValueAndValidity();
    this.newPaymentMethodFormGroup.get('account_number')?.updateValueAndValidity();
    this.newPaymentMethodFormGroup.get('account_type')?.updateValueAndValidity();

    this.paymentMethodDetailsEvent.emit(this.newPaymentMethodFormGroup.value);
  }

  resetForm() {
    this.newPaymentMethodFormGroup.reset();

    this.newPaymentMethodFormGroup.get('payment_method_type')?.setValue('Credit Card');
    this.newPaymentMethodFormGroup.get('account_type')?.setValue('checking');

    this.newPaymentMethodFormGroup.get('payment_method_type')?.updateValueAndValidity();
    this.newPaymentMethodFormGroup.get('account_type')?.updateValueAndValidity();

    if (this.cardForm?.['_iframe']) {
      this.cardForm?.destroy();
    }
  }

  public async displayError(error: any) {
    this.messageService.clear();
    this.messageService.add({
      severity: "error",
      detail: error.message,
      key: 'card-form-message'
    });
  }
  public async validateForm(): Promise<paymentMethod | undefined> {

    try {
      this.messageService.clear();
      this.savePaymentMethodFormSubmitted = true;

      if (!this.newPaymentMethodFormGroup.valid) {
        return;
      }

      this.savePaymentMethodFormSubmitted = false;

      let savePaymentMethodReq: paymentMethod | undefined = undefined;
      const formValues = this.newPaymentMethodFormGroup.value;

      savePaymentMethodReq = {
        name: formValues['name'],
        is_default: 0,
        payment_method_type: formValues['payment_method_type']
      };

      if (formValues['payment_method_type'] == "Credit Card") {
        const result = await this.cardForm.getNonceToken();
        console.log(result)

        savePaymentMethodReq.token = result.nonce;
        savePaymentMethodReq.exp_month = result.expiryMonth;
        savePaymentMethodReq.exp_year = result.expiryYear;
        savePaymentMethodReq.last_digit = result.last4;
        savePaymentMethodReq.type = result.cardType;

      } else if (formValues['payment_method_type'] == "eCheck") {
        savePaymentMethodReq.last_digit = formValues['account_number'].substr(formValues['account_number'].length - 4);
        savePaymentMethodReq.account_number = formValues['account_number'];
        savePaymentMethodReq.routing_number = formValues['routing_number'];
        savePaymentMethodReq.account_name = formValues['account_owner_name'];
        savePaymentMethodReq.type = formValues['account_type'];
      }

      return savePaymentMethodReq;
    } catch (error: any) {
      this.messageService.add({
        severity: "error",
        detail: error.message,
        key: 'card-form-message'
      });
      return undefined;
    }

  }
}
